export const english = {
  feedback: {
    "title": "Send feedback",
    "category": "Category",
    "suggestion": "Suggestion",
    "problem": "Problem",
    "other": "Other",
    "message": "Your feedback",
    "placeholder": "What would you improve, or what went wrong?",
    "email": "Reply email (optional)",
    "send": "Send feedback",
    "sending": "Sending…",
    "success": "Thank you — your feedback has been received.",
    "error": "Could not send your feedback. Your text is still here; please try again.",
    "invalid": "Enter 10–3,000 characters and a valid email if provided.",
    "signIn": "Sign in to send feedback",
    "inbox": "User feedback",
    "empty": "No feedback yet.",
    "reviewed": "Reviewed",
    "markReviewed": "Mark reviewed",
    "refresh": "Refresh",
    "new": "New"
},
  menu: {
    signOut: "Sign Out",
    signIn: "Sign In / Register",
    talkToUs: "Talk to us",
    language: "Language",
    deleteAccount: "Delete Account",
    accountSettings: "Account Settings",
  },
  theme: {
    light: "Light",
    dark: "Dark",
  },
  landing: {
    heroKicker: "For citizens and municipalities worldwide",
    heroSub: "We deliver your voice to the municipality — anywhere in the world.",
    municipalityLogin: "Municipality login",
    pecCardTitle: "Every report reaches municipalities worldwide",
    pecBadge: "Email",
    pecCardBody: "From any city, in any country. Partner municipalities receive reports directly; everywhere else we forward reports to local authorities via email, so no issue stays invisible.",
    pecTitle: "Every report counts, even without a partnership",
    pecBody: "If your municipality isn't a ShapeIt partner yet, we still send every report to local authorities via email, so no issue stays invisible.",
    pecHighlight: "We forward reports to municipalities via email",
    ctaSub: "Join citizens and municipalities around the world making a difference, one report at a time.",
  },
  mapHeader: {
    appName: "Shapeit",
    login: "Log In / Register",
    searchPlaceholder: "Search locations or click anywhere on the map to report any problem",
    clearSearch: "Clear search",
  },
  mapLegend: {
    title: "Shapeit Legend",
    buttonLabel: "Legend",
    dirty: "Dirty",
    unsafe: "Unsafe",
    needsFix: "Needs Fixing",
  },
  dialog: {
    selectLanguage: "Select Your Preferred Language",
    chooseLanguage: "Choose a language for the application interface.",
    confirm: "Confirm",
    welcome: {
      title: "Welcome!",
      message: "Shapeit is here to empower you, we want you to be able to shape your city and transform it into a better place. Every time you spot a problem you can report it, and you can also like other users' reports to give them higher visibility. On our end, we will make sure to keep city authorities up to date with the most pressing issues.",
      message2: "Shapeit is working to partner with municipalities worldwide. Even if your city isn't a partner yet, we forward every report to local authorities via email, so no issue stays invisible. Every report helps build an up-to-date database of urban issues in your area: the more we collect, the stronger our voice will be when we approach local authorities. Now go and make your city a better place!",
      next: "Next",
      button: "Let's Get Started!"
    }
  },
  reports: {
    overview: "Reports Overview",
    trending: "Trending",
    myReports: "My Reports",
    yourReports: "Your Reports",
    recentReports: "Recent Reports",
    by: "by",
    anonymous: "Anonymous",
  },
  usernameSetup: {
    title: "Choose your username",
    description: "Pick a public name shown on your reports. You can change it later in Account Settings.",
    placeholder: "Your username",
    save: "Save",
    saving: "Saving...",
    skip: "Later",
    tooShort: "Username must be at least 2 characters",
    noEmail: "Username cannot contain @",
    success: "Username saved",
    error: "Could not save username",
  },
  reportForm: {
    postAnonymously: "Post anonymously",
    postAnonymouslyHint: "Your name will not be shown on this report.",
    postingAs: "Posting as",
    title: "Submit a Report",
    description: "Description",
    uploadPhoto: "Upload Photo",
    takePhoto: "Take Photo",
    changePhoto: "Change Photo",
    preview: "Preview",
    submit: "Submit Report",
    submitting: "Submitting...",
    loginRequired: "You must be logged in to submit a report",
    uploadFailed: "Failed to upload report",
    photoUploadFailed: "The photo could not be sent. Your report is still here.",
    sendWithoutPhoto: "Send without photo",
    selectIssue: "Please select an issue type",
    selectIssueType: "Select an issue type",
    moderationWarning: "Reports are automatically moderated. Offensive, spam, or inappropriate content will be rejected.",
    rejectedContent: "Your report contains inappropriate content and cannot be published",
    rateLimitExceeded: "You've reached the limit of 5 reports per hour. Please try again later.",
    characterLimit: "Description cannot exceed 500 characters",
    appealLink: "Submit appeal via email",
    offensiveContent: "Your message contains inappropriate language",
    validatingImage: "Validating image...",
        aiAnalyzing: "AI is analyzing...",
    duplicateWarning: "A similar report already exists nearby. Consider upvoting it instead of creating a duplicate.",
    aiSuggestions: "AI Suggestions",
    suggestedTitle: "Suggested title:",
    priority: "Priority:",
    inappropriateImage: "The image contains inappropriate content and cannot be used",
    notRelevantImage: "The photo doesn't seem to show an urban issue. Please upload a photo of the problem you want to report.",
  },
  confirmReport: {
    question: "Do you want to create a report here?",
    yes: "Yes",
    no: "No"
  },
  locationPrompt: "Click on the desired spot to report an issue",
  reportHere: "Report here",
  deleteAccount: {
    title: "Delete Account",
    warning: "This action is irreversible!",
    description: "All your data will be permanently deleted, including:",
    items: {
      reports: "All your reports",
      photos: "All uploaded photos",
      accountData: "Your account information"
    },
    confirmLabel: "Type DELETE to confirm",
    confirmPlaceholder: "DELETE",
    cancel: "Cancel",
    deleteButton: "Delete My Account",
    deleting: "Deleting...",
    success: "Account deleted successfully",
    error: "Failed to delete account"
  },
  gamification: {
    totalReports: "Total reports",
    congratulations: "Congratulations!",
    pointsEarned: "Points earned",
    totalPoints: "Total points",
    currentLevel: "Current level",
    levelUp: "Level Up!",
    nextLevel: "Next level",
    progress: "Progress",
    thankYou: "Thank you for making the city a better place!",
    keepGoing: "Keep reporting to reach the next level!",
    continue: "Continue",
    levels: {
      beginner: "Beginner",
      active_citizen: "Active Citizen",
      urban_observer: "Urban Observer",
      city_guardian: "City Guardian",
      civic_champion: "Civic Champion",
      urban_hero: "Urban Hero"
    },
    messages: {
      beginner: "Welcome to the community!",
      active_citizen: "You're making a difference!",
      urban_observer: "Your eyes make the city better!",
      city_guardian: "You're a true guardian!",
      civic_champion: "Champion of civic duty!",
      urban_hero: "You're an urban hero!"
    }
  },
  onboarding: {
    step1: {
      title: "Welcome to the Map!",
      description: "Here you can see all the reports from your community. Let's learn how to use it!"
    },
    step2: {
      title: "Create a Report",
      description: "Search for a location or click on the map to create a new report about an issue in your area."
    },
    step3: {
      title: "Report Types",
      description: "Different colors represent different types of issues. Click on markers to see details and upvote reports you care about!"
    },
    step4: {
      title: "Your Profile & Gamification",
      description: "Earn points by creating reports and helping your community! Track your level and progress here."
    },
    step5: {
      title: "You're Ready!",
      description: "Start improving your community by reporting issues and engaging with other reports. Every contribution counts!"
    },
    previous: "Previous",
    next: "Next"
  },
    accountSettings: {
    title: "Account Settings",
    openSettings: "Account Settings",
    changeEmail: "Change Email",
    newEmailLabel: "New email address",
    newEmailPlaceholder: "new@email.com",
    changePassword: "Change Password",
    newPasswordLabel: "New password",
    newPasswordPlaceholder: "At least 6 characters",
    passwordTooShort: "Password must be at least 6 characters",
    passwordSuccess: "Password updated successfully",
    changeUsername: "Change Username",
    newUsernameLabel: "New username",
    newUsernamePlaceholder: "Your username",
    usernameTooShort: "Username must be at least 2 characters",
    usernameSuccess: "Username updated successfully",
    deleteAccountTitle: "Delete Account",
    deleteAccountDescription: "Permanently delete your account and all related data. This action cannot be undone.",
    deleteAccountButton: "Delete account",
    save: "Save",
    saving: "Saving...",
    submit: "Send confirmation email",
    submitting: "Sending...",
    invalidEmail: "Invalid email address",
    error: "Error",
    updateFailed: "Could not update",
    successTitle: "Verification email sent",
    successDescription: "We sent a confirmation email to {email}. Check your inbox to confirm the change.",
    showPassword: "Show password",
    hidePassword: "Hide password",
  },
  push: {
    title: "Push Notifications",
    subtitle: "Manage the notifications you receive on your device",
    enable: "Enable push notifications",
    denied: "Permission denied. Enable notifications in your device settings.",
    registered: "Device registered",
    requestPermission: "Request permission to receive notifications",
    resolved: "Report resolved",
    resolvedDesc: "When one of your reports is resolved",
    upvotes: "Upvotes received",
    upvotesDesc: "When someone upvotes your reports",
    achievements: "Achievements unlocked",
    achievementsDesc: "When you unlock a new achievement",
    newReports: "New reports",
    newReportsDesc: "When new reports are created",
    updated: "Preferences updated",
    updateError: "Could not update preferences",
    mobileOnly: "Push notifications are delivered in the mobile app",
  },
  referral: {
    inviteTitle: "Invite friends and earn points!",
    inviteSubtitle: "Create your invite code to start earning 50 points for every friend who signs up.",
    createCode: "Create invite code",
    yourCode: "Your invite code",
    copy: "Copy",
    codeCopied: "Code copied to clipboard!",
    linkCopied: "Invite link copied!",
    directLink: "Direct link",
    stats: "Invite statistics",
    completed: "Completed",
    pending: "Pending",
    total: "Total",
    ambassadorProgress: "Ambassador progress",
    ambassadorUnlocked: "You unlocked the Ambassador badge!",
    shareText: "Join ShapeIt and help improve your city! Use my code {code} to get 50 bonus points 🎁",
    shareTitle: "ShapeIt invite",
  },
  misc: {
    mapLoadFailed: "Failed to load map",
    mapKeyError: "Failed to load Google Maps API key",
    mapKeyMissing: "Google Maps API key not configured",
    mapsLoadError: "Failed to load Google Maps",
    onlyImages: "Only JPEG, PNG and WebP images are allowed",
    imageTooLarge: "Image size must be less than 5MB",
    photoFailed: "Failed to take photo",
    current: "Current",
    progress: "Progress",
  },
  common: {
    share: "Share",
    shareTitle: "Share this report",
    copyLink: "Copy link",
    linkCopied: "Link copied to clipboard!",
    copyFailed: "Failed to copy link",
    loading: "Loading...",
    close: "Close",
    delete: "Delete",
    cancel: "Cancel",
    retry: "Retry",
    login: "Login",
    register: "Register",
    email: "Email",
    password: "Password",
    username: "Username",
    anonymous: "Anonymous",
    notYourReport: "Not your report",
    loginToDelete: "Log in to delete",
    upvotes: "Upvotes",
    reportedBy: "Reported by",
    trending: "Trending",
    trendingReports: "Trending Reports",
    noTrending: "No trending reports yet",
    yourReports: "Your Reports",
    noReportsYet: "You haven't created any reports yet",
    loadingAddress: "Loading address…",
    myLocation: "My location",
    yourLocation: "Your location",
    mapView: "Map view",
    satelliteView: "Satellite view",
    changePhoto: "Change photo",
    uploadingPhoto: "Uploading...",
    photoUpdated: "Profile photo updated",
    photoUploadError: "Could not upload photo",
    removePhoto: "Remove photo",
    inviteFriends: "Invite friends",
    achievements: "Achievements",
    noAchievements: "No achievements unlocked yet",
    statusHistory: "Status history",
    seeTranslation: "See translation",
    seeOriginal: "See original",
    translating: "Translating...",
    translationFailed: "Translation unavailable",
    translatedAutomatically: "Translated automatically",
    deleteConfirm: "Do you want to remove this report?",
    loginToDeleteReports: "Please log in to delete reports",
    onlyOwnReports: "You can only delete your own reports",
  },
  auth: {
    backToMap: "Back to Map",
    subtitle: "Sign in or create an account to report issues in your community",
    login: "Login",
    register: "Register",
    email: "Email",
    password: "Password",
    username: "Username",
    orContinueWith: "Or continue with",
    signInGoogle: "Sign in with Google",
    signUpGoogle: "Sign up with Google",
    signingIn: "Signing in...",
    signIn: "Sign In",
    referralLabel: "Invite code (optional) 🎁",
    referralPlaceholder: "Enter an invite code",
    referralBonus: "You'll receive 50 bonus points with this code! 🎁",
    creatingAccount: "Creating Account...",
    createAccount: "Create Account",
    showPassword: "Show password",
    hidePassword: "Hide password",
  },
  analytics: {
    otherCategory: "Other",
    pageTitle: "Analytics Dashboard",
    pageSubtitle: "Public statistics and transparency on community reports",
    backToMap: "Back to map",
    noData: "No data available",
    communityTitle: "Community Analytics",
    communitySubtitle: "Real-time civic reporting statistics",
    municipalityScopedSubtitle: "Real-time statistics for reports in your municipality",
    totalReports: "Total reports",
    inProgress: "In progress",
    resolved: "Resolved",
    avgTime: "Average time",
    categoryTitle: "Breakdown by category",
    categoryDesc: "Types of reports received",
    trendTitle: "Last 7 days trend",
    trendDesc: "Number of daily reports",
    topAreasTitle: "Most reported areas",
    topAreasDesc: "Areas with the most active reports",
    adminTitle: "Advanced Analytics (Admin)",
    adminSubtitle: "Detailed metrics visible to administrators only",
    dau: "Daily active users",
    wau: "Weekly active users",
    mau: "Monthly active users",
    avgSession: "Average session duration",
    minutesShort: "min",
    mapInteractions: "Map interactions",
    perSession: "Average per session",
    reportsPerUser: "Reports per user",
    average: "Average",
    completionRate: "Completion rate",
    loginToReport: "Login → Report",
    funnelTitle: "Conversion funnel",
    funnelDesc: "User journey analysis (last 7 days)",
    users: "Users",
    conversionPct: "% Conversion",
    devicesTitle: "Device distribution",
    devicesDesc: "Analysis of the devices used",
  },
};
